import { scaleSmallAnimation } from '../../../utils/keyframes.mjs';

const BORDER_RADIUS = 10;
const contentStyle = {
  borderRadius: BORDER_RADIUS,
  "@media (prefers-reduced-motion: no-preference)": {
    animationDuration: scaleSmallAnimation.duration.open,
    animationTimingFunction: scaleSmallAnimation.timingFunction,
    willChange: "transform, opacity",
    '&[data-align="start"]': {
      '&[data-side="top"]': { transformOrigin: "20% 80%" },
      '&[data-side="bottom"]': { transformOrigin: "20% 20%" }
    },
    '&[data-align="center"]': {
      '&[data-side="top"]': { transformOrigin: "50% 80%" },
      '&[data-side="bottom"]': { transformOrigin: "50% 20%" }
    },
    '&[data-align="end"]': {
      '&[data-side="top"]': { transformOrigin: "80% 80%" },
      '&[data-side="bottom"]': { transformOrigin: "80% 20%" }
    },
    '&[data-state="open"]': {
      animationName: scaleSmallAnimation.show(0.98)
    },
    '&[data-state="closed"]': {
      animationName: scaleSmallAnimation.hide(0.98),
      animationDuration: scaleSmallAnimation.duration.close
    }
  }
};
const contentInnerStyle = {
  borderRadius: BORDER_RADIUS,
  overflow: "hidden",
  position: "relative",
  backgroundColor: "$white",
  boxShadow: "$popover"
};

export { contentInnerStyle, contentStyle };
//# sourceMappingURL=styles.mjs.map
